import { memo } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import { IconButton, List, ListItem, ListItemIcon, ListItemText, ListSubheader, Typography } from '@mui/material';

interface AttachedModelRowProps {
  heading: string;
  title: string;
  onDelete: () => void;
}

function AttachedModelRow(props: AttachedModelRowProps) {
  const { heading, title, onDelete } = props;

  return (
    <List
      subheader={
        <ListSubheader disableGutters>
          <Typography variant="subtitle1">
            <strong>{heading}</strong>
          </Typography>
        </ListSubheader>
      }
    >
      <ListItem
        secondaryAction={
          <IconButton edge="end" onClick={onDelete}>
            <DeleteIcon />
          </IconButton>
        }
      >
        <ListItemIcon>
          <ViewInArIcon />
        </ListItemIcon>

        <ListItemText primary={title} />
      </ListItem>
    </List>
  );
}

export default memo(AttachedModelRow);
